import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import Layout from "../components/Layout";
import { MAINTENANCE_TIERS } from "../data/content";

export default function Maintenance() {
  return (
    <Layout>
      <section className="max-w-6xl mx-auto px-6 py-16 md:py-24">
        <p className="text-xs tracking-[0.3em] uppercase text-pink-500 font-bold mb-4">Maintenance Plans</p>
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter">Keep it pristine, pay less</h1>
        <p className="text-zinc-400 mt-4 max-w-2xl text-lg">Lock in recurring details and unlock serious savings. When you confirm your Venmo/Zelle is charged the set amount per week or month, you receive the discounted price automatically — plus bonus add-ons on frequent plans.</p>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {MAINTENANCE_TIERS.map((t, i) => (
            <div key={i} className={`rounded-2xl border p-7 ${i>=2?"border-pink-500/60 bg-[#1a1013]":"border-white/10 bg-[#121212]"}`} data-testid={`maint-tier-${t.freq}`}>
              <h3 className="text-lg font-bold">{t.name}</h3>
              <p className="mt-4 text-4xl font-extrabold text-pink-500">{t.discount}</p>
              <p className="text-sm text-zinc-400 mt-2">{t.bonus}</p>
              <Link to="/book" target="_blank" rel="noopener noreferrer" className="mt-6 block text-center bg-white/5 hover:bg-pink-600 border border-white/15 rounded-full py-2.5 text-sm font-semibold transition-colors">Start plan</Link>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-2xl border border-white/10 bg-[#121212] p-8 md:p-12">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight">Are maintenance plans too expensive?</h2>
          <p className="text-zinc-300 mt-4 leading-relaxed max-w-3xl">Do you love a pristine car but can't afford monthly or quarterly full details? Don't need every feature of our full packages? With a <strong>customizable maintenance plan</strong> you select which parts of the car you really want cleaned — starting as low as <span className="text-pink-500 font-bold">$100/month</span> or <span className="text-pink-500 font-bold">$135 every 3 months</span>.</p>
          <div className="mt-6 grid gap-3 sm:grid-cols-2 max-w-2xl">
            {["Select exactly what gets cleaned","Skip what you don't need","Save on every recurring detail","Bonus add-ons on frequent plans"].map((f)=>(
              <div key={f} className="flex items-center gap-3 text-zinc-300"><Check size={18} className="text-pink-500 shrink-0" />{f}</div>
            ))}
          </div>
          <Link to="/custom-plan" className="mt-8 inline-flex bg-pink-600 hover:bg-pink-500 text-white font-semibold rounded-full px-8 py-4 transition-colors active:scale-95" data-testid="maint-custom-btn">Build a customizable plan</Link>
        </div>
      </section>
    </Layout>
  );
}
